import { useTranslation } from 'react-i18next'

export const T = ({ children }: { children: string }) => {
  const { t } = useTranslation()
  return <>{t(children)}</>
}
